<template>
  <div class="userSetPageWrap">
    <div class="userSet" :class="page == 2 ? 'bg' : ''">
      <div class="commonBg"></div>
      <div class="userSet_content" v-show="page == 0">
        <div class="uploadPage_toptitle">
          <div class="uploadPage_toptitlebox">
            <van-icon name="arrow-left" @click="back" />
            <div class="details_top_title">设置</div>
            <span v-show="this.$store.state.system !== 'android'"></span>
            <van-icon
              name="close"
              v-show="
                this.$store.state.system == 'android' &&
                applets != 'xcx' &&
                !$store.state.isXcx &&
                this.$store.state.isInGame
              "
              @click="closeCommunity"
            />
          </div>
        </div>
        <div
          class="userSet_content_list bg"
          :class="item.top == 'top' ? 'userSet_content_list_top' : ''"
          v-for="item in list"
          :key="item.id"
          @click="setListClick(item.id)"
        >
          {{ item.name }}
        </div>
        <!-- <div class="userSet_content_list bg" @click="setListClick(2)" v-if="!loginFlag && $store.state.gameType == 1">
          社区登录码<span>用于在微信公众号登录社区</span>
        </div> -->
        <div
          class="userSet_content_list bg"
          v-if="$store.state.bindCodeShow && !$store.state.isInGame"
          @click="setListClick(3)"
        >
          绑定游戏信息<span>同步游戏内社区数据</span>
        </div>
        <div
          class="userSet_content_list bg"
          v-if="$store.state.bindPhoneShow"
          @click="setListClick(4)"
        >
          绑定手机号<span>社区网页端/微信小程序端登录该社区账号</span>
        </div>
        <!-- <div class="userSetPageWrap_logOutbox">
          <div class="userSetPageWrap_logOut" @click="logOut" v-if="loginFlag">
            退出登录
          </div>
        </div> -->
        <div class="quit-box">
          <i class="quit_login" v-if="!$store.state.isInGame" @click="quitLogin"
            >退出登录</i
          >
        </div>
      </div>
      <messageSet v-if="page == 1" @changePage="changePage"></messageSet>
      <feedback v-if="page == 2" @changePage="changePage"></feedback>
      <loginCode v-if="page == 3" @changePage="changePage"></loginCode>
      <changeAccount v-if="page == 4" @changePage="changePage"></changeAccount>
      <bindPhone v-if="page == 5" @changePage="changePage"></bindPhone>
    </div>
    <sideRight v-if="$padFalg != 'other'"></sideRight>
  </div>
</template>
<script>
import messageSet from './userSet/messageSet.vue';
import feedback from './userSet/feedback.vue';
import loginCode from './userSet/loginCode.vue';
import changeAccount from './userSet/changeAccount.vue';
import bindPhone from './userSet/bindPhone.vue';
import sideRight from '@/components/sideRight';
import http from '../../../api/get';
import { Toast, Dialog } from 'vant';
import * as _code from '../../../utils/code';
import qs from 'qs';
export default {
  name: 'userSet',
  components: {
    messageSet,
    feedback,
    sideRight,
    loginCode,
    changeAccount,
    bindPhone
  },
  data() {
    return {
      applets: window.user.weixcode ? 'xcx' : '',
      bg: 'bg',
      page: 0,
      loginFlag: window.user.weixcode,
      list: [
        { id: 0, name: '消息设置', top: 'top' },
        { id: 1, name: '建议与反馈', top: '' }
      ]
    };
  },
  mounted() {
    if (this.$route.params.code) {
      //绑定码传参
      this.setListClick(2);
    }
  },
  methods: {
    quitLogin() {
      Dialog.confirm({
        message: '确认退出登录吗？'
      }).then(() => {
        http.webLogoff().then((res) => {
          if (res.data.code == 0) {
            this.$store.commit('changeLoginStatus', 0);
            this.$store.commit('changeToken', '');
            let objToken = JSON.parse(sessionStorage.getItem('userObj'));
            objToken.token = '';
            objToken.loginStatus = false;
            sessionStorage.setItem('userObj', JSON.stringify(objToken));
            this.$store.commit(
              'setUserInfo',
              JSON.parse(sessionStorage.getItem('userObj'))
            );
            this.$router.push({ name: 'homePage' });
            setTimeout(() => {
              if (location.href.indexOf('login=') != -1) {
                const params = new URLSearchParams(window.location.search);
                params.set('login', 'no');
                const urlObj = new URL(window.location.href);
                urlObj.search = params.toString();
                const newUrl = urlObj.href;
                window.history.replaceState({}, '', newUrl);
                setTimeout(() => {
                  location.reload();
                }, 100);
              } else {
                location.reload();
              }
            }, 200);
          }
        });
      });
    },
    setListClick(id) {
      this.page = id + 1;
    },
    changePage(num) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.page = num;
    },
    logOut() {
      Dialog.confirm({
        message: '确认退出登录吗？'
      }).then(() => {
        let form = {
          openId: this.$store.state.openId
        };
        http.unbindLogincode(qs.stringify(form)).then((res) => {
          if (res.data.code == 0) {
            this.$store.commit('changeToken', '');
            this.$router.push('/xcxlogin');
          } else {
            this.errorMessage(res.data);
          }
        });
      });
    },
    back() {
      this.$router.go(-1);
    },
    closeCommunity() {
      window.pd.onBBSClose();
    },
    //错误提示
    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        Toast(msg);
      }
    }
  }
};
</script>
<style scoped></style>